/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */






// Maverick
$(document).ready(function () {
  $( window ).on( "load", function() {
    $(".current-collection_Gallery-Inspiration .ProductItem__Title").on('click', function(event){
      event.preventDefault();
      $('.gallery-modal').toggle();
    });
  });
  
  $('.custom_slider').flickity({
  // options
          "prevNextButtons": false,
          "pageDots": false,
          "adaptiveHeight": true,
          "watchCSS": true,
          "dragThreshold": 8
});
  
  // 2nd carousel, navigation
    $('.custom_nav').flickity({
      asNavFor: '.custom_slider',
      contain: true,
      pageDots: false,
      prevNextButtons: false
    });
  
 
      $('.fix-text td').each(function () {
        if ($(this).text() == 'Steam show') {
            $(this).text('Steam Shower');
        }
        if ($(this).text() == 'Fireplace/Cooktop surround' || $(this).text() == 'Shower wall' || $(this).text() == 'Exterior wall' || $(this).text() == 'Steam shower' || $(this).text() == 'Light residential'){
            $(this).css('text-transform', 'capitalize');
        }
        
        if ($(this).text() == 'Poor, Spa or Water Feature(fully submerge)') {
            $(this).text('Pool, Spa or Water Feature');
        }
        
        if ($(this).text() == 'Interior Wall/Backflash') {
            $(this).text('Interior Wall/Backsplash');
        }        
      });
  
  
  
  $('[data-group=pages]').setAttribute('aria-label', 'Inspiration Gallery');
  



  
});



  $('.desktop-carousel').flickity({
    "prevNextButtons": false,
    "pageDots": false,
    "wrapAround": false,
    "contain": true,
    "cellAlign": "center",
    "watchCSS": true,
    "dragThreshold": 8,
//     "groupCells": true,
    "draggable": false
});

  $('.inspo-carousel-footer').flickity({
    "prevNextButtons": false,
    "pageDots": false,
    "wrapAround": true,
    "contain": true,
    "cellAlign": "center",
    "watchCSS": true,
    "dragThreshold": 8,
    "freeScroll": true, 
    "fullscreen": true,
    "touchVerticalScroll": false
});

$(document).ready(function() {
    function updateText() {
        $productFormLabels.each(function() {
            var $this = $(this);
            if ($this.text().trim() === 'Finishes') {
                $this.text('Finish');
            }
        });
    }
    var $productFormLabels = $('.ProductForm__Label');
    var observerOptions = { childList: true, subtree: true };
    var tabInputs = $('input[name="tabset"]');
    var $tab3 = $('#tab3');
    var $videosParagraph = $('#videos-paragraph');
var linkForFaq = document.querySelector('.link-for-faq');
var targetElement = document.querySelector('#from-contact-direct');
var linkForFaq = document.querySelector('.link-for-faq');
var targetElement = document.querySelector('#from-contact-direct');

function getHeaderOffset() {
    var screenWidth = window.innerWidth;

    if (screenWidth < 768) {
        return -125; // Mobile
    } else if (screenWidth >= 768 && screenWidth < 1024) {
        return -125; // Tablet
    } else {
        return -300; // Desktop
    }
}
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            updateText();
        });
    });

    updateText();

    observer.observe(document.body, observerOptions);

    tabInputs.on('change', function() {
        if ($tab3.is(':checked')) {
            $videosParagraph.show();  
        } else {
            $videosParagraph.hide();  
        }
    });

    tabInputs.filter(':checked').trigger('change');

linkForFaq.addEventListener('click', function(event) {
    event.preventDefault();
    const elementPosition = targetElement.getBoundingClientRect().top;
    const headerOffset = getHeaderOffset(); // Get the offset dynamically
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
});
});
